import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import useUserStore from './modules/user'
import useAppStore from './modules/app'
import usePageStore from './modules/page'
import useChatStore from './modules/chat'

// 创建
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
export { useUserStore, useAppStore, usePageStore, useChatStore }

// 导出
export default pinia
